var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-studies"},[_c('g-hero',{attrs:{"content":{
      title: _vm.content.hero.title,
      htmltext: _vm.content.description,
    }}}),_c('content-search',{attrs:{"content":_vm.content,"type":"case-studies"}}),(_vm.content.footerCtas)?_c('g-ctas',{attrs:{"content":_vm.content.footerCtas}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }